/**
 * SMB Component - why choose avast
 * @copyright 2018 AVAST Software s.r.o.
 * @author Alex Ratman
 * @since 2018-08-20
 *
 * DESCRIPTION:
 * Functionality for 'why choose avast'
 *
 */

"use strict";

$(document).ready(function() {
    var icons = $('.why-choose-avast__box-icon');
    var descriptions = $('.why-choose-avast__description');

    icons.on('click', function() {
        var reason = $(this).data('reason');

        // mark icon and p.label as active/inactive
        icons.children().removeClass('active');
        $(this).children().addClass('active');


        // mark descriptions as active/inactive
        descriptions.each(function() {
            $(this).data('reason') === reason ? $(this).addClass('active') : $(this).removeClass('active');
        });
    });
});